import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import scriptLoader from "react-async-script-loader";

import "./HolidayHomes.scss";
import { Helmet } from "react-helmet";

const HolidayHomes = ({Module, isScriptLoaded, isScriptLoadSucceed}) => {

    if (isScriptLoaded && isScriptLoadSucceed) {
        window.AirbnbAPI.bootstrap();
    }
    return (
        <>

            <section className={`leadoo-script ${Module.bg_clr ? Module.bg_clr.toLowerCase() : "" }`}>
                <Container>
                    <Row>
                        <Col>
                            {Module?.title && 
                                <h2>{Module?.title}</h2>
                            }

                            <div className="holiday_homes">
                            {Module?.holiday_homes_modules?.length > 0 && Module?.holiday_homes_modules.map((item, i) => {
                                return(
                                    <div 
                                        class="airbnb-embed-frame" 
                                        data-id={item.embed_code_id} 
                                        data-view="home">
                                        <a href={`https://www.airbnb.co.in/rooms/${item.embed_code_id}?guests=1&amp;adults=1&amp;s=66&amp;source=embed_widget`}>View on Airbnb</a>
                                    </div>
                                )
                            })}
                            </div>
                            
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default scriptLoader(["https://www.airbnb.com/embeddable/airbnb_jssdk"]) (HolidayHomes);